<ngx-extended-pdf-viewer
    [src]="blobUrl"
    [backgroundColor]="'#404040'"
    [theme]="'dark'"
    [showUnverifiedSignatures]="true"
    [language]="language"
    [textLayer]="true"
>
</ngx-extended-pdf-viewer>
